export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function chatContentFileType(val) {
  //获取最后一个.的位置
  var index = val.lastIndexOf(".");
  //获取后缀
  var ext = val.substr(index + 1);
  let imgs = [
    'png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'
  ]
  if (imgs.indexOf(ext.toLowerCase()) !== -1) {
    // img
    return 'il@:' + val
  } else {
    // file
    return 'fl@:' + val
  }

}

export function fileType(val, id, s, p, obj = {}) {

  // let baseURL = 'http://192.168.10.48:8000'
  // let baseURL = 'https://stage-chat.bestcaco.com/cus'
  let baseURL = ''
  if (process.env.NODE_ENV === 'development') {
    // 开发环境
    baseURL = 'https://stage-chat.bestcaco.com/cus'
  } else if (process.env.NODE_ENV === 'production') {
    // 正式环境
    baseURL = 'https://chat-xpro.bestcaco.com/cus'
  }

  if ((val.indexOf('il@:') !== -1)) {
    obj.type = 'pic'
    obj.url = `${baseURL}/f_d/?i=${id}&ts=${s}&p=${p}&f=${val.replace('il@:', '')}`
  } else if ((val.indexOf('fl@:') !== -1)) {
    obj.type = 'file'
    obj.url = `${baseURL}/f_d/?i=${id}&ts=${s}&p=${p}&f=${val.replace('fl@:', '')}`
  } else {
    obj.type = 'word'
    obj.url = ''
  }
  return obj
}